import { useRef, useState } from 'react';
import {
  MenuItem,
  IconButton,
  Paper,
  Popper,
  MenuList,
  ClickAwayListener,
  Box,
} from '@mui/material';
import { IUserPanelProps } from '../../types';
import { useTranslation } from 'react-i18next';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import * as Constants from '../data/Constants';
import { PopperStyle } from '../../style/Styles';
import { useNavigate } from 'react-router';

/**
 * Renders the user name and a menu to logout
 * @param {IUserPanelProps} props the properties for the user panel component
 * @returns {JSX.Element} the user panel
 */

export const UserPanel = ({ user }: IUserPanelProps) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const anchorRef = useRef<HTMLButtonElement>(null);
  const [arrowRef, setArrowRef] = useState(null);
  const open = Boolean(anchorElement);

  const onInternalLogout = () => {
    navigate('/logout', { replace: true });
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };
  return (
    <>
      <span color="secondary">{user} </span>
      <IconButton
        ref={anchorRef}
        onClick={handleClick}
        sx={{ cursor: 'pointer', color: 'white', padding: '5px' }}
      >
        <AccountCircleIcon sx={{ height: '1.3em', width: '1.3em' }} />
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorElement}
        placement="bottom"
        sx={{ zIndex: 100 }}
        disablePortal
        modifiers={[
          ...Constants.popperModifier,
          {
            name: 'arrow',
            enabled: true,
            options: {
              element: arrowRef,
            },
          },
        ]}
      >
        <Box
          component="div"
          id="arrow"
          data-popper-arrow
          className="arrow"
          ref={setArrowRef}
          sx={PopperStyle.arrow}
        />
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList id="user-menu">
              <MenuItem onClick={onInternalLogout}>{t('button.logout')}</MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </>
  );
};
